import axios from "axios";
import { toast } from "react-toastify";
const formatToTwoDecimals = (num) => {
    return (Math.round(num * 100) / 100).toFixed(2);
};

export const getCachedEthereumPrice = async () => {
  const cachedData = localStorage.getItem("ethereumPriceData");
  const today = new Date().toISOString().split("T")[0];

  if (cachedData) {
    const { price, date } = JSON.parse(cachedData);
    if (date === today && price > 0) {
      return formatToTwoDecimals(price);
    }
  }

  try {
    const res = await axios.get("https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd");
    const rawPrice = res.data?.ethereum?.usd;

    if (!rawPrice || rawPrice === 0) {
      throw new Error("Invalid ETH price in API response");
    }
    const formattedPrice = formatToTwoDecimals(rawPrice);
    localStorage.setItem(
      "ethereumPriceData",
      JSON.stringify({ price: formattedPrice, date: today })
    );
    return formattedPrice;
  } catch (err) {
    console.error("Failed to fetch Ethereum price:", err);
    toast.error("Error fetching Ethereum price");
    return "0.00";
  }
};